angular.module("warehouses")

    .controller("WarehousesListCtrl", ['LoginService', '$state', '$rootScope', '$scope', 'Restangular', 'gridService', '$filter', '$translate', 'modalService',
        function (LoginService, $state, $rootScope, $scope, Restangular, gridService, $filter, $translate,modalService) {

            $scope.allowWrite = LoginService.permissionExist("WAREHOUSES_WRITE");
            $rootScope.title = $filter('translate')('warehouses.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('warehouses.title') }
            ];

            $scope.gridOptionsWarehouses = {
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'name', displayName: $filter('translate')('warehouses.name'), enableFiltering: true, enableHiding: false },
                    { name: 'location', displayName: $filter('translate')('warehouses.location'), enableFiltering: true, enableHiding: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('warehouses.button_edit'), action: 'ui-sref="warehouses.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('warehouses.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    return Restangular.all('Warehouses').getList(options)
                }
            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("warehouses.edit", { id: rowEntity.id });
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('warehouses.button_delete'),
                    message: $filter('translate')('warehouses.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Warehouses', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('warehouses.delete_success'));
                            $scope.gridOptionsWarehouses.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };


    }]);